/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import RedactorEditor from '../RedactorEditor';

import uuid from 'uuid/v4';

const NumberedList = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {

  const initialState = {
    type: 'NumberedList',
    open: 'last',
    sort: 'asc',
    elements: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [showOptions, setShowOptions] = useState(false);
  const [updatedData, setUpdatedData] = useState(false);
  const [elements, setElements] = useState([]);

  const [open, setOpen] = useState('last');
  const [sort, setSort] = useState('asc');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          open: currentOpen,
          sort: currentSort,
          elements: currentElements,
        } = component;

        setState(component);
        setOpen(currentOpen);
        setSort(currentSort);
        setElements(currentElements);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      open,
      sort,
      elements,
    }

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    open,
    sort,
    updatedData,
  ]);

  const changeSizeForElement = (e, index) => {
    elements[index]['size'] = e.target.value;
    setElements(elements);
    setUpdatedData(uuid());
  }

  const titleChange = (e) => {
    const itemIndex = e.target.getAttribute('itemindex');
    const { name, value } = e.target;
    // Items saved before a field existed have no object to write into — caption
    // is the current example, but this keeps any future field from throwing.
    if (!elements[itemIndex][name]) elements[itemIndex][name] = {};
    elements[itemIndex][name][activeLanguage] = value
    setElements(elements);
    setUpdatedData(uuid());
  }
  const titleChangeFromRedactor = (value, itemIndex) => {
    //const itemIndex = e.target.getAttribute('itemindex');
    elements[itemIndex]['text'][activeLanguage] = value
    setElements(elements);
    setUpdatedData(uuid());
  }

  const pushAnItemToElements = () => {
    const lastItemId = elements.slice(-1)[0];
    const order = sort === "asc" ? 1 : -1;
    const futureItemId = lastItemId && lastItemId.itemId ? parseInt(lastItemId.itemId) + order : 1;

    elements.push({
      title: {en: ''},
      subtitle: { en: '' },
      label: { en: '' },
      image: { en: '' },
      caption: { en: '' },
      size: '100',
      text: { en: '' },
      visible: true,
      itemId: futureItemId,
    })
    setElements(elements);
    setUpdatedData(uuid());
  }

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    switch (source.droppableId) {
      // origin same as destination, order elements
      case destination.droppableId: {
        //const newOrder = reorder(elements, source.index, destination.index);
        [elements[source.index], elements[destination.index]] = [elements[destination.index], elements[source.index]];

        setElements(elements);
        setUpdatedData(uuid());
        break;
      }

      default: {
        break;
      }
    }
  };

  const removeFromElements = index => {
    elements.splice(index, 1)
    setElements(elements);
    setUpdatedData(uuid());
  }

  const setVisibleValue = e => {
    const itemIndex = e.target.getAttribute('itemindex');
    elements[itemIndex].visible = e.target.value === "0" ? true : false;
    setElements(elements);
    setUpdatedData(uuid());
  }

  const updateElementList = e => {
    const itemIndex = e.target.getAttribute('itemindex');
    elements[itemIndex].itemId = e.target.value;
    setElements(elements);
    setUpdatedData(uuid());
  }


  return (
    <DragDropContext onDragEnd={onDragEnd}>
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex items-end py-4">
        <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
            Open on load
                  </label>
          <div className="relative">
            <select
              className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
              value={open}
              onChange={e => setOpen(e.target.value)}
            >
              <option value={'all'}>All visible</option>
              <option value={'none'}>None visible</option>
              <option value={'last'}>Last visible</option>
              <option value={'first'}>First visible</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                /></svg>
            </div>
          </div>
        </div>
        <div className="xl:w-1/4 lg:w-1/4 w-full">
          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
            Sort order
                  </label>
          <div className="relative">
            <select
              className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
              value={sort}
              onChange={e => setSort(e.target.value)}
            >
              <option value={'asc'}>Ascendent</option>
              <option value={'desc'}>Descendent</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                /></svg>
            </div>
          </div>
        </div>
        {/* <div className="w-full md:w-full md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Open
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            id="grid-first-name"
            type="text"
            onChange={titleChange}
            value={text[activeLanguage]}
          />
        </div> */}
        {/* <div
          className={`bg-blue-light border-blue-darker ml-4 cursor-pointer flex items-center justify-center py-6 rounded text-center text-white w-10`}
          onClick={() => setShowOptions(!showOptions)}
        >
          <svg
            className={`fill-current h-4 w-4 ${showOptions ? 'rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            /></svg>
        </div> */}
      </div>
      {/* End */}
      {/* BLOCK OPTIONS */}

        <Droppable droppableId="selected">
        {(provided, snapshot) => (
          <div ref={provided.innerRef}
            className={`${snapshot.isDraggingOver ? 'bg-grey' : 'bg-grey-lighter'} min-h-30 mb-4 rounded w-full p-2 relative`}>
            {elements.map((element, index) => {

              const {
                title = { en: '' },
                subtitle = { en: '' },
                label = { en: '' },
                image,
                caption = { en: '' },
                size = '100',
                text = { en: '' },
                itemId = 1,
                visible = true,
              } = element;

              return (
                <Draggable
                  key={`${id}_${index}`}
                  draggableId={`${id}_${index}`}
                  index={index}
                  activeLanguage={activeLanguage}>
                  {(provided, snapshot, component) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      className={`relative bg-gray-200 bg-white min-h-30 mb-2 rounded w-full p-2`}
                      style={provided.draggableProps.style}
                    >
                      <div className="flex flex-wrap mb-2">
                        <div className="border cursor-pointer font-bold mr-1 p-2 px-4 rounded text-center">
                          <input
                            className="m-0 p-0 text-center w-5 font-bold"
                            type="text"
                            itemindex={index}
                            name="itemId"
                            onChange={updateElementList}
                            value={itemId}
                          />
                        </div>
                        <div className="bg-grey-light cursor-pointer text-center flex-2 p-2 rounded" {...provided.dragHandleProps}> =</div>
                        {/* Toggle */}
                        <div className="border border-green-lightest flex items-center justify-start mx-1 p-2 pl-5 rounded">
                          <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                            <input
                              type="checkbox"
                              itemindex={index}
                              value={visible ? 1 : 0}
                              onChange={setVisibleValue}
                              checked={visible ? 1 : 0}
                              className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                            />
                            <label className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
                          </div>
                        </div>
                        {/* End Toggle */}
                        <div className="cursor-pointer p-2 rounded" onClick={()=> removeFromElements(index)}><span className="font-icon icon-close-btn1" /></div>
                      </div>

                      <div className="w-full md:w-full md:mb-0">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                          Title
                        </label>
                        <input
                          className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                          type="text"
                          itemindex={index}
                          name="title"
                          onChange={titleChange}
                          value={title[activeLanguage]}
                        />
                      </div>
                      <div className="w-full md:w-full md:mb-0 mt-2">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                          Sub Title
                        </label>
                        <input
                          className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            itemindex={index}
                            name="subtitle"
                          type="text"
                          onChange={titleChange}
                          value={subtitle[activeLanguage]}
                        />
                      </div>
                      <div className="w-full md:w-full md:mb-0 mt-2">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                          Label
                        </label>
                        <input
                          className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                          itemindex={index}
                          name="label"
                          type="text"
                          onChange={titleChange}
                          value={label[activeLanguage]}
                        />
                      </div>
                      <div className="w-full flex flex-wrap mt-2">
                        <div className="flex-1 mr-2">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                          Image
                        </label>
                        <input
                          className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            itemindex={index}
                            name="image"
                          type="text"
                          onChange={titleChange}
                          value={image[activeLanguage]}
                        />
                      </div>
                        <div className="">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                          Size
                  </label>
                        <div className="relative">
                          <select
                            className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
                            value={size}
                            onChange={(e) => changeSizeForElement(e, index)}
                          >
                            <option value={'100'}>100%</option>
                            <option value={'50'}>50%</option>
                            <option value={'25'}>25%</option>
                          </select>
                          <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
                            <svg
                              className="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              /></svg>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div className="w-full md:w-full md:mb-0 mt-2">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                          Image caption
                        </label>
                        <input
                          className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                          itemindex={index}
                          name="caption"
                          type="text"
                          onChange={titleChange}
                          value={caption[activeLanguage] || ''}
                        />
                      </div>
                      <div className="w-full md:w-full md:mb-0 mt-2">
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                          Text
                        </label>
                        <RedactorEditor
                          text={text[activeLanguage]}
                          setText={(text) => titleChangeFromRedactor(text, index)}
                          id={`${id}_${index}`}
                        />
                      </div>
                    </div>

                  )}
                </Draggable>
              )
            })}
              {provided.placeholder}
          </div>

        )}

      </Droppable>


      <div className="hover:bg-blue-light hover:text-white rounded w-full">
        <div
          className={`block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500 text-center`}
          onClick={pushAnItemToElements}
        >+</div>
      </div>
      {/* BLOCK OPTIONS */}

      {/* <label className={`flex flex-col font-americaMonoRegular ${slider ? 'text-xxs' : 'text-xs w-1/12 justify-center'} uppercase text-black pt-0 items-center px-2`}>
        Text Color
        <div className={`pb-0 ${slider ? 'mt-2px mx-2' : 'mt-6px ml-1'}`}>
          <label className="switch mb-0 pb-0 h-6">
            <input className="switch" checked={!!isColorWhite} onChange={setChangeColor} type="checkbox" />
            <div className="switch-slider btn-bw switch-round" />
          </label>
        </div>
      </label> */}
    </div>
    </DragDropContext>
  );
};

NumberedList.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
NumberedList.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default NumberedList;
